import LazyLoad from 'vanilla-lazyload';

export default () => {
  const lazyLoadOptions = {
    elements_selector: '.lazy'
  };
  const pageLazyLoad = new LazyLoad(lazyLoadOptions);
};



// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/lazy.js